<template>
  <div
    class="roster-card"
    v-match-heights="{
      el: ['.img-wrap', '.roster-body', '.roster-footer'],
      disabled: [575]
    }"
  >
    <div class="img-wrap">
      <img :src="generateImageUrl(roster.profileImage)" alt="Pic" />
    </div>
    <div class="roster-body">
      <div class="roster-title">
        <div class="name">
          {{ roster.fname }}
          <span>{{ `${roster.mname} ` }}{{ roster.lname }}</span>
        </div>
        <!-- <router-link :to="``">
          <div class="view-details">View Profile</div>
        </router-link>-->
      </div>
      <ul class="roster-description">
        <li>
          <div class="list-title">Position :</div>
          <div class="list-info">
            {{ roster.position.map(r => r["name"]).join(", ") }}
          </div>
        </li>
        <li>
          <div class="list-title">Height / Grad Year :</div>
          <div class="list-info">
            {{ roster.height() }} / {{ roster.gradeYear }}
          </div>
        </li>
        <li>
          <div class="list-title">Throw / Bats :</div>
          <div class="list-info">
            {{ roster.throwingHandName }} / {{ roster.battingHandName }}
          </div>
        </li>
        <li>
          <div class="list-title">City / State :</div>
          <div class="list-info">
            {{ roster.city }} / {{ roster.stateName }}
          </div>
        </li>
        <li>
          <div class="list-title">School :</div>
          <div class="list-info">{{ roster.highSchool }}</div>
        </li>
      </ul>
    </div>
    <div class="roster-footer">
      <div class="button-wrap">
        <div v-if="!checkIsProfile()">
        <div class="view-details" v-if="roster.profileLink">
          <a class="color-secondary" :href="checkUrl()" target="_blank"
            >View Profile</a
          >
          <a-icon type="double-right" />
        </div>
        </div>
        <div v-if="!$route.params.id && onlyClubCoach()">
          <a-popconfirm
            title="Are you sure you want to deactivate this player?"
            @confirm="deactivateUser"
            ok-text="Yes"
            cancel-text="No"
            v-if="active"
          >
            <div class="view-details deactivate">
              Deactivate
              <a-icon type="exclamation-circle" />
            </div>
          </a-popconfirm>
          <a-popconfirm
            title="Are you sure you want to activate this player?"
            @confirm="activateUser"
            ok-text="Yes"
            cancel-text="No"
            v-else
          >
            <div class="view-details activate">
              Activate
              <a-icon type="check-circle" />
            </div>
          </a-popconfirm>
        </div>
      </div>
      <div class="button-wrap" v-if="!$route.params.id && onlyClubCoach()">
        <span>
          <a-button
            type="primary"
            icon="edit"
            class="save-button"
            @click="handleEdit"
            >Edit</a-button
          >
        </span>
        <span>
          <a-popconfirm
            title="Are you sure you want to delete this player?"
            @confirm="handleDelete()"
            ok-text="Yes"
            cancel-text="No"
          >
            <a-button type="danger" icon="delete">Delete</a-button>
          </a-popconfirm>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { Base } from "@/models";
const STORE_KEY = "rosterStore";

export default {
  name: "RosterCard",
  props: {
    roster: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    profileId() {
      return Base.profileId();
    }
  },
  methods: {
    async deactivateUser() {
      await this.$store.dispatch(`${STORE_KEY}/editPlayer`, {
        id: this.roster.id,
        isActive: false,
        slug: "clubroster",
        message: "Player deactivated successfully."
      });
      this.$store.dispatch(
        `${STORE_KEY}/removePlayerFromRoster`,
        this.roster.id
      );
    },
    async activateUser() {
      await this.$store.dispatch(`${STORE_KEY}/editPlayer`, {
        id: this.roster.id,
        isActive: true,
        slug: "clubroster",
        message: "Player activated successfully."
      });
      this.$store.dispatch(
        `${STORE_KEY}/removePlayerFromRoster`,
        this.roster.id
      );
    },
    async handleDelete() {
      await this.$store.dispatch(`${STORE_KEY}/deletePlayer`, {
        id: this.roster.id,
        slug: "clubroster"
      });
      this.$store.dispatch(
        `${STORE_KEY}/removePlayerFromRoster`,
        this.roster.id
      );
    },
    checkIsProfile(){
      const currentUser = localStorage.getItem("user-permissions");
      return currentUser === '"player"' || currentUser === '"premiumclubHeadCoach"' || currentUser === '"clubHeadCoach"';
    },
    checkUrl(){

      const logged_user_profile = localStorage.getItem("profile-id");
      const profile_link = this.roster.profileLink;
      const newURL = new URL(profile_link);
      const newPath = newURL.pathname.split("/")[1]
      const path =  profile_link.replace(newPath, logged_user_profile);
      return path;
    },
    handleEdit() {
      this.$router.push(`/${this.profileId}/roster/${this.roster.id}/edit`);
    }
  }
};
</script>

<style lang="scss">
.roster-card {
  border-radius: 4px;
  overflow: hidden;
  max-width: 350px;
  margin: 0 auto;
  background: #ffffff;
  box-shadow: 0px 4px 10px 5px rgba(209, 209, 209, 0.6);
  .img-wrap {
    overflow: hidden;
    display: flex;
    max-height: 250px;
    background: #f0f0f0;
    img {
      margin: 0 auto;
      height: 100%;
      object-fit: cover;
    }
  }
  .roster-body {
    padding: 15px 15px;
    .roster-title {
      display: flex;
      justify-content: space-between;
      .name {
        font-size: 14px;
        font-weight: 500;
        padding-bottom: 5px;
        margin-bottom: 15px;
        position: relative;
        text-transform: capitalize;
        color: #4a4a4a;
        span {
          font-size: 18px;
          font-weight: 900;
          color: #2d2d2d;
          display: block;
        }
        &::before {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 3px;
          max-width: 100px;
          background: #cc2f2a;
        }
      }
      .view-details {
        font-size: 12px;
        font-weight: 600;
        color: #2a328a;
        text-align: left;
        font-style: italic;
        padding-bottom: 2px;
        position: relative;
        &::before {
          content: "";
          position: absolute;
          left: 0;
          bottom: 0;
          height: 1px;
          width: 100%;
          background: #2a328a;
        }
      }
    }
    .roster-description {
      margin: 0;
      padding: 0;
      list-style: none;
      li {
        padding: 3px 0;
        color: #4a4a4a;
        font-weight: 500;
        font-size: 14px;
        display: flex;
        flex-wrap: wrap;
        .list-title {
          font-weight: 600;
          color: #000000;
          width: 100px;
        }
        .list-info {
          padding-left: 10px;
          width: calc(100% - 100px);
        }
        &:first-child {
          padding-top: 0;
        }
        &:last-child {
          padding-bottom: 0;
          // .list-info {
          //   padding-left: 0;
          //   padding-top: 5px;
          //   width: 100%;
          // }
        }
      }
    }
  }
  .roster-footer {
    padding: 15px 15px;
    background: #fff;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    .view-details {
      color: #2a328a;
      text-align: left;
      &.deactivate {
        color: #d73228;
        cursor: pointer;
      }
      &.activate {
        color: green;
        cursor: pointer;
      }
    }
    .button-wrap {
      // display: none;
      padding-top: 15px;
      display: flex;
      justify-content: space-between;
      .ant-btn {
        font-size: 12px;
        padding: 0 15px;
        line-height: 26px;
        height: 28px;
      }
      .save-button {
        background: #2a328a;
        border-color: #2a328a;
      }
    }
  }
}
</style>
